export const BUILD_ID = '338d5263-e8bb-47f3-b02f-f13bbb9b0c1c';
export const ENV = 'dev';
